<template>
  <div style="width:1200px;margin: 0 auto">
<!--    <div class="go-back" @click="$router.go(-1)">-->
<!--      <i class="el-icon-arrow-left"></i>返回-->
<!--    </div>-->
    <div class="paper-detail">
      <div class="paper-title">
        <span class="paper-bg">专利</span>
        <div class="paper-title-style">{{ patentData.title }}</div>
      </div>
      <div
        style="
          width: 100%;
          border-bottom: 1px dashed #e8eaee;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      ></div>
      <div style="display: flex">
        <div style="display: flex; width: 50%">
          <div class="flex flex-wrap">
            <!--      发明人-->
            <span class="textSpan">发明人：</span>
            <div v-if="!patentData.authors || patentData.authors.length === 0">
              -
            </div>
            <div
              v-else
              style="
                display: flex;
                margin-right: 11px;
                align-items: center;
                cursor: pointer;
              "
              v-for="(item, index) in patentData.authors.length > 3 &&
              !isAuthorsMore
                ? patentData.authors.slice(0, 3)
                : patentData.authors"
              :key="index"
              @click="goPersonalDetails(item.scholarId)"
            >
              <el-avatar class="avatar" :size="18" :src="item.avatarUrl" />
              <div style="margin-left: 6px" class="textContent">
                {{ item.scholarName }}
              </div>
            </div>
            <span
              @click="authorsMore"
              v-if="
                patentData.authors &&
                patentData.authors.length > 3 &&
                !isAuthorsMore
              "
              class="textSpan pointer"
              style="color: rgb(46, 31, 136)"
              >更多>></span
            >
          </div>
        </div>

        <!-- 专利类型-->
        <div class="text-title">
          <span class="textSpan noWrap">专利类型：</span>
          <div class="textContent">{{ patentData.patentType || '-' }}</div>
        </div>
      </div>
      <div style="display: flex; margin-top: 8px">
        <!-- 申请人-->
        <div class="text-title">
          <span class="textSpan noWrap">申请人：</span>
          <div class="textContent">{{ patentData.applicantName || '-' }}</div>
        </div>
        <!-- 申请时间-->
        <div class="text-title">
          <span class="textSpan noWrap">申请时间：</span>
          <div class="textContent">
            {{
              patentData.applicationDate
                ? formatToDate(patentData.applicationDate)
                : '-'
            }}
          </div>
        </div>
      </div>
      <div style="display: flex; margin-top: 8px">
        <!-- 专利授权号-->
        <div class="text-title">
          <span class="textSpan noWrap">专利授权号：</span>
          <div class="textContent">
            {{ patentData.authorizationNum || '-' }}
          </div>
        </div>
        <!-- 专利分类号-->
        <div class="text-title">
          <span class="textSpan noWrap" style="">专利分类号：</span>
          <div
            class="textContent"
            style="
              white-space: pre-wrap;
              word-break: break-all;
              word-wrap: break-word;
            "
          >
            {{ patentData.classCode || '-' }}
          </div>
        </div>
      </div>
      <div style="display: flex; margin-top: 8px">
        <!-- 专利申请号-->
        <div class="text-title">
          <span class="textSpan noWrap">专利申请号：</span>
          <div class="textContent">
            {{
              patentData.applicationNum == null
                ? '-'
                : patentData.applicationNum
            }}
          </div>
        </div>
        <!-- 公开号-->
        <div class="text-title">
          <span class="textSpan noWrap">公开号：</span>
          <div class="textContent">
            {{ patentData.publicationNum || '-' }}
          </div>
        </div>
      </div>
      <div style="display: flex; margin-top: 8px">
        <!-- 专利国家代码-->
        <div class="text-title">
          <span class="textSpan noWrap">专利国家代码：</span>
          <div class="textContent">
            {{ patentData.applicationAreaCode || '-' }}
          </div>
        </div>
        <!-- 申请人及区域代码-->
        <div class="text-title">
          <span class="textSpan noWrap">申请人及区域代码：</span>
          <div class="textContent">
            {{ patentData.applicationAreaCode || '-' }}
          </div>
        </div>
      </div>
      <div style="display: flex; margin-top: 8px">
        <!-- 优先权日-->
        <div class="text-title">
          <span class="textSpan noWrap">优先权日：</span>
          <div class="textContent">
            {{
              patentData.priorityDate
                ? formatToDate(patentData.priorityDate)
                : '-'
            }}
          </div>
        </div>
        <!-- 专利状态-->
        <div class="text-title">
          <span class="textSpan noWrap">专利状态：</span>
          <div class="textContent" style="color: #00c27c">
            {{ patentData.legalStatus || '-' }}
          </div>
        </div>
      </div>
      <div style="display: flex; margin-top: 8px">
        <!-- 公开日期-->
        <div class="text-title">
          <span class="textSpan noWrap">公开日期：</span>
          <div class="textContent">
            {{
              patentData.publicationDate
                ? formatToDate(patentData.publicationDate)
                : '-'
            }}
          </div>
        </div>
        <!-- 页数-->
        <div class="text-title">
          <span class="textSpan noWrap">页数：</span>
          <div class="textContent">
            {{ patentData.pageCnt || '-' }}
          </div>
        </div>
      </div>

      <!-- 摘要-->
      <div style="text-align: start; margin-top: 8px">
        <span class="textSpan"
          >摘要：<span
            class="textContent"
            v-html="patentData.summary || '-'"
          ></span
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatToDate } from '@/utils/dateUtil';
import { getPatentDetailApi } from '@/api/details';

export default {
  name: 'patentDetail',
  data() {
    return {
      formatToDate,
      patentData: {},
      patentId: this.$route.query.id,
      isAuthorsMore: false,
    };
  },
  async created() {
    if (process.env.VUE_APP_NAME === 'guojiao') {
      document.title = '专利详情';
    }
    this.getPatentDetails();
  },
  methods: {
    authorsMore() {
      this.isAuthorsMore = true;
    },
    goPersonalDetails(id) {
      if (id) {
        let obj = {
          name: 'talentDetail',
          query: { id },
        };
        let routeData = this.$router.resolve(obj);
        window.open(routeData.href, '_blank');
      } else {
        this.$message.warning({
          message: '暂无详情数据',
          type: 'warning',
        });
      }
    },
    getPatentDetails() {
      getPatentDetailApi(this.$route.query.id).then((res) => {
        this.patentData = res.data;
      });
    },
  },
};
</script>

<style scoped lang="less">
.go-back {
  color: #667085;
  font-size: 16px;
  margin-left: 30px;
  margin-top: 20px;
  cursor: pointer;
  text-align: start;
  margin-bottom: 10px;
}
.paper-detail {
  height: fit-content;
  align-content: center;
  background: #ffffff;
  padding: 25px 30px;
  border-radius: 16px;

  .paper-title {
    display: flex;
    align-items: flex-start;

    .paper-bg {
      font-size: 16px;
      color: #c3a062;
      background: #f5f0e6;
      padding: 4px 8px;
      border-radius: 4px;
      flex-shrink: 0;
    }

    .paper-title-style {
      font-size: 20px;
      margin-left: 9px;
      font-weight: bold;
      color: #101828;
      text-align: left;
      line-height: 24px;
    }
  }

  .text-title {
    display: flex;
    width: 50%;
    text-align: start;
  }

  .textSpan {
    color: #667085;
    font-size: 16px;
    line-height: 24px;
  }

  .textContent {
    color: #101828;
    font-size: 16px;
    line-height: 24px;
  }
}

.avatar {
  min-width: 18px;
}

.noWrap {
  white-space: nowrap;
}
</style>
